<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.IbanVerification"
    :ui-title="`Verify your income`"
    ui-subtitle="Please provide us with your IBAN for your salary account 
                    and we will verify your income with your bank."
    ui-error-message="We have to verify your income in order to offer you this product"
  >
    <!-- :ui-secondary-action="doItLaterIBAN" -->
    <FieldsetIBAN title="Enter IBAN" />
  </StepModel>
</template>
<script>
import StepModel from "@/lib/components/models/step";
import FieldsetIBAN from "@/forms/components/cards/stp-card/steps/fieldsets/iban-number";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import otpService from "@/forms/api/services/otp";

import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import resetService from "@/lib/helpers/reset-service";

import FIELD_NAMES from "@/forms/constants/field-names";

import { OTP_VALIDATE } from "@/forms/constants/services";

export default {
  name: "StepIban",

  mixins: [FormComponentMixin],

  props: {
    title: {
      type: String,
      default: "Verify your income"
    },
    subtitle: {
      type: String,
      default: "Let’s verify your mobile number to make sure we can reach you"
    },
    changePhoneAction: {
      type: Function,
      default: () => {}
    }
  },

  components: {
    StepModel,
    FieldsetIBAN
  },
  mounted() {
    //GoogleTag.getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {}
};
</script>
